export default "__VITE_ASSET__CgRW6Zfl__"